// ====================================================================================
// twingle.module
// ====================================================================================

export const init = () => {
    let attempts = 0;

    // if document.ready needed
    const whenComplete = () => {
        if (++attempts > 30) return;
        if (document.readyState === "complete") {
            window.addEventListener("message", function (event) {
                if (event && event.data && event.data.type === "donationFinished") {
                    console.log(event.data);
                    dataLayer.push({
                        "event": "add_payment_info",
                        "ecommerce": {
                            "currency": "EUR",
                            "payment_type": event.data.value.paymentMethod,
                            "value": event.data.value.amount,
                            "tax": 0,
                            "items": [{
                                price: event.data.value.amount,
                                item_id: event.data.value.target,
                                item_variant: event.data.value.rythm,
                                item_category: "Spende",
                                item_category2: "Twingle",
                                quantity: 1
                            }]
                        }
                    });
                    dataLayer.push({
                        "event": "purchase",
                        "ecommerce": {
                            "currency": "EUR",
                            "value": event.data.value.amount,
                            "tax": 0,
                            "items": [{
                                price: event.data.value.amount,
                                item_variant: event.data.value.rythm,
                                item_id: event.data.value.target,
                                item_category: "Spende",
                                item_category2: "Twingle",
                                quantity: 1
                            }]
                        }
                    });
                }
            }, false);
        } else {
            setTimeout(() => {
                whenComplete();
            }, 400);
        }
    };
    whenComplete();
};
